<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    active: true,
                  },
                ]"
              ></vs-breadcrumb>
            </div>
          </div>

          <!-- New Design start -->
          <div class="">
            <ExploreTrainings />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
// import TabView from "../../commonPages/DashboardTabs"
import ExploreTrainings from "../../commonPages/ExploreTrainings"

export default {
  data: () => ({
    isSidebar: false,
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    ExploreTrainings,
  },
   mounted() {

  },

};
</script>

<style scoped>
.modal-btn {
  padding: 0px 50px;
  height: 30px;
  border-radius: 10px;
}
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

@media (max-width: 768px) {
  /* ul.date-ul {
    margin-top: -30px !important;
    display: block;
    margin-bottom: 25px;
  }
  .date-ul li {
    padding: 2px;
  }
  .cardheader {
    display: block;
  } */
  .card-col {
    width: 100% !important;
  }

  ul.date-ul {
    margin-top: 5px;
  }

  .date-ul li.start-date {
    padding-right: 26px;
  }

  .training-title {
    font-size: 14px;
  }
}

@media (max-width: 991.98px) {
  /* ul.date-ul {
    margin-top: -16px;
    display: block;
  } */
  .date-ul li.start-date {
    padding-right: 26px;
  }

  .card-col {
    width: 100% !important;
  }

  ul.date-ul {
    margin-top: 5px;
  }
}
.not-full {
  padding: 4px 4px !important;
}
</style>
